import React from 'react';
import styled from 'styled-components';

const MainContentWrapper = styled.div`
  min-height: calc(100% - 80px);
`;

const MainContent = ({ children }) => {
  return <MainContentWrapper>{children}</MainContentWrapper>;
};

export default MainContent;
